import * as React from 'react';

import { LucidePackage } from 'lucide-react';

import { ServiceRecord } from '~/modules/transportation/types';

interface ServiceAssetLabelProps {
  assetQuantities: ServiceRecord['assetQuantities'];
}

export const ServiceAssetLabel = ({
  assetQuantities,
}: ServiceAssetLabelProps) => {
  const { label, extraLabel } = React.useMemo(() => {
    if (!assetQuantities || assetQuantities.length === 0) {
      return { label: '', extraLabel: null };
    }
    const sorted = [...assetQuantities].sort((a, b) => b.quantity - a.quantity);
    const label = `${sorted[0].quantity} x ${sorted[0].assetType?.name ?? ''}`;
    const extraLabel =
      assetQuantities.length > 1 ? ` + ${assetQuantities.length - 1}` : null;
    return { label, extraLabel };
  }, [assetQuantities]);

  if (!assetQuantities || assetQuantities.length === 0) {
    return null;
  }

  if (!label) return null;

  return (
    <div className="@ServiceAssetLabel flex shrink-0 items-center gap-1 text-foreground/60">
      <LucidePackage size={12} className="shrink-0" />
      <div className="truncate text-xs">
        {label}
        {extraLabel && <span>{extraLabel}</span>}
      </div>
    </div>
  );
};
